// React builder
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Link, Route, Switch, NavLink } from "react-router-dom";
import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container } from "@mui/material";

// Styles
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';
import LodingComponent from "./loding";

// App Icons
import MenuIcon from "@mui/icons-material/Menu";
import { FiHome } from "react-icons/fi";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import InventoryIcon from '@mui/icons-material/Inventory';
import TripOriginIcon from '@mui/icons-material/TripOrigin';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import ViewDayIcon from '@mui/icons-material/ViewDay';
import TextureIcon from '@mui/icons-material/Texture';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ChatIcon from '@mui/icons-material/Chat';
import PersonIcon from '@mui/icons-material/Person';
import ListAltIcon from '@mui/icons-material/ListAlt';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ToysIcon from '@material-ui/icons/Toys';
import TimelineIcon from '@material-ui/icons/Timeline';
import TimelineOutlinedIcon from '@material-ui/icons/TimelineOutlined';
import AccountBalanceRoundedIcon from '@material-ui/icons/AccountBalanceRounded';
import ViewHeadlineRoundedIcon from '@material-ui/icons/ViewHeadlineRounded';
import CategoryIcon from '@mui/icons-material/Category';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import PostAddIcon from '@mui/icons-material/PostAdd';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SummarizeIcon from '@mui/icons-material/Summarize';
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import SecurityIcon from '@mui/icons-material/Security';
import DeblurIcon from '@mui/icons-material/Deblur';
import GroupIcon from '@mui/icons-material/Group';
import InventoryTwoToneIcon from '@mui/icons-material/InventoryTwoTone';
import ArticleIcon from '@mui/icons-material/Article';
import NoteIcon from '@mui/icons-material/Note';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import BalanceIcon from '@mui/icons-material/Balance';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import BusinessIcon from '@mui/icons-material/Business';

//Auth
import { AuthProvider, useAuth } from "./AuthContext";

//Logout
import Logout from "./Logout";

//SessionTimeOut
//import SessionTimeout from "./SessionTimeout";

// Company 
import CompanyEdit from "./components/pages/Company/Edit";
// Home
import Home from "./components/pages/Home";
// Master 
import MasterIndex from "./components/pages/Master/Index";
import AccountHeadEdit from "./components/pages/Master/AHDEdit";
import BKEdit from "./components/pages/Master/BankEdit";
import StaffEdit from "./components/pages/Master/StaffEdit";
import AssetEdit from "./components/pages/Master/AssetEdit";
import COSEdit from "./components/pages/Master/CSEdit";
import otherEdit from "./components/pages/Master/OtherEdit";
import CapitalEdit from "./components/pages/Master/CapitalEdit";

// Balance Sheet 
import BalanceSheetIndex from "./components/pages/BalanceSheet/Index";

// Role
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";
//Item 
import ItemCreate from "./components/pages/Item/Create";
import ItemEdit from "./components/pages/Item/Edit";
import ItemIndex from "./components/pages/Item/Index";

// User
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//Category
import CategoryCreate from "./components/pages/Category/Create";
import CategoryEdit from "./components/pages/Category/Edit";
import CategoryIndex from "./components/pages/Category/Index";


//Purchase
import PurchaseIndex from "./components/pages/purchase/Index";
import PurchaseCreate from "./components/pages/purchase/Create";
import PurchaseEdit from "./components/pages/purchase/Edit";
import PurchaseDetails from "./components/pages/purchase/Details";
//Sale
import SaleIndex from "./components/pages/Sale/Index";
import SaleCreate from "./components/pages/Sale/Create";
import SaleEdit from "./components/pages/Sale/Edit";
import SaleDetails from "./components/pages/Sale/Details";

//JournalEntry
import JournelEntry from "./components/pages/JournalEntryPage/Create";
import JournelEntryIndex from "./components/pages/JournalEntryPage/Index";
import JournalEntryEdit from "./components/pages/JournalEntryPage/Edit";
import JournalEntryDetails from "./components/pages/JournalEntryPage/Details";
// Receipt
import ReceiptIndex from "./components/pages/Receipt/Index";
import ReceiptCreate from "./components/pages/Receipt/Create";
import ReceiptDetails from "./components/pages/Receipt/Details";
import ReceiptEdit from "./components/pages/Receipt/Edit";
// Payment
import PaymentIndex from "./components/pages/Payment/Index";
import PaymentCreate from "./components/pages/Payment/Create";
import PaymentDetails from "./components/pages/Payment/Details";
import PaymentEdit from "./components/pages/Payment/Edit";
//stock Journal 

import StockJournalIndex from "./components/pages/StockJournal/Index";
import StockJournalCreate from "./components/pages/StockJournal/Create";
import StockJournalDetails from "./components/pages/StockJournal/Details";
import StockJournalEdit from "./components/pages/StockJournal/Edit";
//Purchase Return
import PurchaseReturnIndex from "./components/pages/PurchaseReturn/Index";
import PurchaseReturnCreate from "./components/pages/PurchaseReturn/Create";
import PurchaseReturnEdit from "./components/pages/PurchaseReturn/Edit";
import PurchaseReturnDetails from "./components/pages/PurchaseReturn/Details";

//Reports
import CreditorDebitorReport from "./components/pages/Report/CreditorDebitor";
import CustomerOutstandingReport from "./components/pages/Report/CustomerOutstanding";
import SupplierOutstandingReport from "./components/pages/Report/SupplierOutstanding";
import StockItemReport from "./components/pages/Report/StockItem";
import StockRawMaterialReport from "./components/pages/Report/StockRawMaterial";
import Ledger from "./components/pages/Report/Ledger";
import SaleRegister from "./components/pages/Report/SaleRegister";
import PurchaseRegisterReport from "./components/pages/Report/PurchaseRegister";
import CashBook from "./components/pages/Report/CashBook";
import Salegstreport from "./components/pages/Report/SaleGstReport";
import SaleHSNCReport from "./components/pages/Report/SaleHSNC";
import Stock from "./components/pages/Report/Stock";
import TrialBalanceReport from "./components/pages/Report/TrialBalance";
import DailySaleProfitReport from "./components/pages/Report/DailySaleProfit";
import SaleAnalysisReport from "./components/pages/Report/SaleAnalysis";
import PartyandItemWiseReport from "./components/pages/Report/party&ItemWise";
import PurchasePartyandItemWiseReport from "./components/pages/Report/PuchaseParty&ItemWise";

//Sale Return 
import SaleReturnIndex from "./components/pages/SaleReturn/Index";
import SaleReturnCreate from "./components/pages/SaleReturn/Create";
import SaleReturnEdit from "./components/pages/SaleReturn/Edit";
import SaleReturnDetails from "./components/pages/SaleReturn/Details";

//Income Or Expense
import IncomeExpenseIndex from "./components/pages/IncomeExpense/Index";
import IncomeExpenseCreate from "./components/pages/IncomeExpense/Create";
import IncomeExpenseEdit from "./components/pages/IncomeExpense/Edit";
import IncomeExpenseDetails from "./components/pages/IncomeExpense/Details";
// Payment and Receipt
import PaymentAndReceiptIndex from "./components/pages/PaymentAndReceipt/Index";
import PaymentAndReceiptCreate from "./components/pages/PaymentAndReceipt/Create";
import PaymentAndReceiptDetails from "./components/pages/PaymentAndReceipt/Details";
import PaymentAndReceiptEdit from "./components/pages/PaymentAndReceipt/Edit";

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);
  const [reportOpen, setReportOpen] = useState(false);
  const [otherOpen, setOtherOpen] = useState(false);
  const [userOpen, setuserOpen] = useState(false);
  const [itemOpen, setItemOpen] = useState(false);

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const handleMasterClick = () => {
    setMasterOpen(!masterOpen);
  };

  const handleReportClick = () => {
    setReportOpen(!reportOpen);
  };

  const handleOtherClick = () => {
    setOtherOpen(!otherOpen);
  };

  const handleUserClick = () => {
    setuserOpen(!userOpen);
  };

  const handleItemClick = () => {
    setItemOpen(!itemOpen);
  };

  const { companyName, companyId, isSuperAdmin, superCompanyId, roleName, username, permissions } = useAuth();

  const [fontSize, setFontSize] = useState(window.innerWidth < 768 ? '12px' : '16px');

  useEffect(() => {
    const handleResize = () => {
      setFontSize(window.innerWidth < 768 ? '12px' : '16px');
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const hasReadMasterPermission = permissions.includes('Read Master');
  const hasReadTransactionPermission = permissions.includes('Read Transaction');
  const hasReadAccountsPermission = permissions.includes('Read Accounts');
  const hasReadAdministrationPermission = permissions.includes('Read Administration');
  const hasReadReadReportsPermission = permissions.includes('Read Reports');

  return (
    <Router>
      <AuthProvider>
        {/* <SessionTimeout /> */}

        <AppBar position="static" style={{ backgroundColor: '#003A6B', height: '55px' }}>
          <Toolbar style={{ minHeight: '55px', padding: '0 24px' }}>

            {/* Left Side - Menu Icon */}
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>

            {/* Center - Logo & Title */}
            <Link
              to="/Home"
              style={{
                textDecoration: 'none',
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FiHome style={{ marginRight: '8px' }} />
              <Typography
                variant="h6"
                //className="dual-text"
                style={{
                  fontWeight: 'bolder',
                  fontSize: fontSize,
                  color: 'white',
                }}
              >
                {companyName}
              </Typography>
            </Link>

            {/* Right Side - Push items to the right */}
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', gap: '10px' }}>

              <div className="white-icon" style={{ marginTop: '5px', marginLeft: '10px' }}>
                <Logout />
              </div>
            </div>

          </Toolbar>
        </AppBar>

        <Drawer anchor="left" open={drawerOpen} onClose={handleDrawerClose} style={{ color: '#000957' }}>
          <div style={{ fontWeight: 'bold', marginTop: '10px' }}>

            <Typography variant="h6" className="dual-text"
              style={{
                fontWeight: 'bold',
                fontSize: '13px',
                marginLeft: '15px',
                color: '#3A0519',
                marginRight: '10px',
              }}
            >
              {companyName}
            </Typography>

          </div>

          <List>

            {hasReadMasterPermission && (
              <ListItem button onClick={handleMasterClick}>
                <ListItemText primary="MASTER" sx={{ fontFamily: 'monospace' }} />
                {masterOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}


            <Collapse in={masterOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px', fontFamily: 'monospace' }}>

                <ListItem button component={NavLink} to="/CompanyEdit" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <BusinessIcon style={{ color: '#80B9AD', height: '20px' }} /><ListItemText primary="Company" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/BalanceSheetIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <DeblurIcon style={{ color: '#7E99A3' }} /> <ListItemText primary="Balance Sheet" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/MasterIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <PersonIcon style={{ color: 'black' }} /> <ListItemText primary="Registration" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CategoryIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <ListAltIcon style={{ color: '#6F826A', height: '20px' }} /><ListItemText primary="Category" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ItemIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <CategoryIcon style={{ color: '#B2C9AD', height: '20px' }} /><ListItemText primary="Item" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>

            {hasReadTransactionPermission && (
              <ListItem button onClick={handleItemClick}>
                <ListItemText primary="TRANSACTION" />
                {itemOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}


            <Collapse in={itemOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px', fontFamily: 'monospace' }}>
                <ListItem button component={NavLink} to="/PurchaseIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <InventoryIcon style={{ color: '#BFD8AF', height: '20px' }} /><ListItemText primary="Purchase" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseReturnIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <AssignmentReturnIcon style={{ color: '#3D0301', height: '20px' }} /><ListItemText primary="Purchase Return" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <ShoppingCartIcon style={{ color: '#3E3F5B', height: '20px' }} /><ListItemText primary="Sale" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleReturnIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <AssignmentReturnIcon style={{ color: '#AC7D88', height: '20px' }} /><ListItemText primary="Sale Return" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/StockJournalIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <InventoryTwoToneIcon style={{ color: '#532257', fontWeight: 'bolder' }} />  <ListItemText primary="Stock Journal" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>

            {hasReadAccountsPermission && (
              <ListItem button onClick={handleOtherClick}>
                <ListItemText primary="ACCOUNTS" />
                {otherOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}

            <Collapse in={otherOpen} timeout="auto" unmountOnExit>

              <List style={{ paddingLeft: '16px' }}>
                <ListItem button component={NavLink} to="/JournelEntryIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <PostAddIcon style={{ color: '#BE5985', height: '20px' }} /><ListItemText primary="Journal Entry " style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/IncomeExpenseIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <TimelineOutlinedIcon style={{ color: '#626F47', height: '20px' }} /><ListItemText primary="Income / Expense" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PaymentIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <PaymentIcon style={{ color: '#78B3CE', height: '20px' }} /><ListItemText primary="Payment" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/ReceiptIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <ReceiptLongIcon style={{ color: '#6A9C89', height: '20px' }} /><ListItemText primary="Receipt" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PaymentAndReceiptIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <AccountBalanceIcon style={{ color: '#3B1C32', height: '20px' }} /><ListItemText primary="Payment & Receipt" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>

            </Collapse>

            {hasReadReadReportsPermission && (
              <ListItem button onClick={handleReportClick}>
                <ListItemText primary="REPORT" />
                {reportOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}

            <Collapse in={reportOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>

                <ListItem button component={NavLink} to="/CashBook" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <CurrencyRupeeIcon style={{ color: '#7E6363', height: '20px' }} /><ListItemText primary="Cash Book" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Ledger" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <SummarizeIcon style={{ color: '#D0B8A8', height: '20px' }} /><ListItemText primary="Ledger" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CreditorDebitorReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: '#987070', height: '20px' }} /><ListItemText primary="Creditors/Debitors" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/CustomerOutstandingReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <PermIdentityIcon style={{ color: '#3C5B6F', height: '20px' }} /><ListItemText primary="Customer Outstanding" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SupplierOutstandingReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <SupervisedUserCircleIcon style={{ color: '#FDAF7B', height: '20px' }} /><ListItemText primary="Supplier Outstanding" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchaseRegisterReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <NoteIcon style={{ color: '#94A684', height: '20px' }} /><ListItemText primary="Purchase Register" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleHSNCReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <ArticleIcon style={{ color: '#B4B4B8', height: '20px' }} /><ListItemText primary="Sale HSNC" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleRegister" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <ArticleIcon style={{ color: '#B1C29E', height: '20px' }} /><ListItemText primary="Sale Register" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleGstReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <TextSnippetIcon style={{ color: '#818C78', height: '20px' }} /><ListItemText primary="Sale GST Report" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/Stock" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <ShowChartIcon style={{ color: '#123524', height: '20px' }} /><ListItemText primary="Stock" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/DailySaleProfitReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <AttachMoneyIcon style={{ color: '#123524', height: '20px' }} /><ListItemText primary="Daily Sale Profit" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/SaleAnalysisReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <AnalyticsIcon style={{ color: '#123524', height: '20px' }} /><ListItemText primary="Sale Analysis" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/TrialBalanceReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <BalanceIcon style={{ color: '#80B9AD', height: '20px' }} /><ListItemText primary="Trial Balance" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>
                <ListItem button component={NavLink} to="/PartyandItemWiseReport" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <TextSnippetIcon style={{ color: '#818C78', height: '20px' }} /><ListItemText primary="Sales Report" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

                <ListItem button component={NavLink} to="/PurchasePartyandItemWiseReport" activeClassName="selected" onClick={handleDrawerClose}>
                  <SummarizeIcon style={{ color: '#987070', height: '20px' }} /><ListItemText primary="Purchase Report" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>


              </List>
            </Collapse>

            {hasReadAdministrationPermission && (
              <ListItem button onClick={handleUserClick}>
                <ListItemText primary="USER" />
                {userOpen ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
            )}

            <Collapse in={userOpen} timeout="auto" unmountOnExit>
              <List style={{ paddingLeft: '16px' }}>
                {roleName == "SuperAdmin" && (
                  <ListItem button component={NavLink} to="/UserIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <PeopleAltIcon style={{ color: '#ABBA7C', height: '20px' }} /><ListItemText primary="User" style={{ marginLeft: '3px', color: 'black' }} />
                  </ListItem>
                )}

                {roleName == "SuperAdmin" && (
                  <ListItem button component={NavLink} to="/RoleIndex" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                    <AccessibilityIcon style={{ color: '#536493', height: '20px' }} /><ListItemText primary="Role" style={{ marginLeft: '3px', color: 'black' }} />
                  </ListItem>
                )}

                <ListItem button component={NavLink} to="/PasswordChange" activeClassName="selected" onClick={handleDrawerClose} style={{ height: '40px' }}>
                  <SecurityIcon style={{ color: 'darkolivegreen', height: '20px' }} /><ListItemText primary="Change Password" style={{ marginLeft: '3px', color: 'black' }} />
                </ListItem>

              </List>
            </Collapse>

          </List>
        </Drawer>

        <Container maxWidth="xl">
          <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/Home" exact component={Home} />


            {/* Item */}
            <Route path="/ItemIndex" component={ItemIndex} />
            <Route path="/ItemCreate" component={ItemCreate} />
            <Route path="/ItemEdit/:id" component={ItemEdit} />

            {/* Role */}
            <Route path="/RoleIndex" component={RoleIndex} />
            <Route path="/RoleDetail/:id" component={RoleDetail} />

            {/* User */}
            <Route path="/UserIndex" component={UserIndex} />
            <Route path="/UserCreate" component={UserCreate} />
            <Route path="/UserEdit/:id" component={UserEdit} />
            <Route path="/UserDetail/:id" component={UserDetail} />
            <Route path="/PasswordChange" component={PasswordChange} />

            {/* Category */}
            <Route path="/CategoryIndex" component={CategoryIndex} />
            <Route path="/CategoryCreate" component={CategoryCreate} />
            <Route path="/CategoryEdit/:id" component={CategoryEdit} />

            {/* Master  */}
            <Route path="/MasterIndex" component={MasterIndex} />
            {/* Masteredit id as masterId and mtypeid as masterTypeid  */}
            <Route path="/AccountHeadEdit/:id/:Mtypeid" component={AccountHeadEdit} />
            <Route path="/AssetEdit/:id/:Mtypeid" component={AssetEdit} />
            <Route path="/BKEdit/:id/:Mtypeid" component={BKEdit} />
            <Route path="/StaffEdit/:id/:Mtypeid" component={StaffEdit} />
            <Route path="/CapitalEdit/:id/:mid" component={CapitalEdit} />
            {/* <Route path="/otherEdit/:id/Mtypeid" component={otherEdit} /> */}
            <Route path="/COSEdit/:id/:Mtypeid" component={COSEdit} />

            {/* BalanceSheet  */}
            <Route path="/BalanceSheetIndex" component={BalanceSheetIndex} />


            {/* Purchase */}
            <Route path="/PurchaseIndex" component={PurchaseIndex} />
            <Route path="/PurchaseCreate" component={PurchaseCreate} />
            <Route path="/PurchaseEdit/:id" component={PurchaseEdit} />
            <Route path="/PurchaseDetails/:id" component={PurchaseDetails} />
            {/* Sale */}
            <Route path="/SaleIndex" component={SaleIndex} />
            <Route path="/SaleCreate" component={SaleCreate} />
            <Route path="/SaleEdit/:id" component={SaleEdit} />
            <Route path="/SaleDetails/:id" component={SaleDetails} />

            {/* Logout */}
            {/* <Route path="/Logout" component={Logout} /> */}

            {/* Other Routes */}
            {/* JournalEntry */}
            <Route path="/JournelEntry" component={JournelEntry} />
            <Route path="/JournelEntryIndex" component={JournelEntryIndex} />
            <Route path="/JournalEntryEdit/:id" component={JournalEntryEdit} />
            <Route path="/JournalEntryDetails/:id" component={JournalEntryDetails} />
            {/* Receipt */}
            <Route path="/ReceiptIndex" component={ReceiptIndex} />
            <Route path="/ReceiptCreate" component={ReceiptCreate} />
            <Route path="/ReceiptDetails/:id" component={ReceiptDetails} />
            <Route path="/ReceiptEdit/:id" component={ReceiptEdit} />
            {/* Payment */}
            <Route path="/PaymentIndex" component={PaymentIndex} />
            <Route path="/PaymentCreate" component={PaymentCreate} />
            <Route path="/PaymentDetails/:id" component={PaymentDetails} />
            <Route path="/PaymentEdit/:id" component={PaymentEdit} />
            {/* Loading Component */}
            {/* Purchase Return */}
            <Route path="/PurchaseReturnIndex" component={PurchaseReturnIndex} />
            <Route path="/PurchaseReturnCreate/:id" component={PurchaseReturnCreate} />
            <Route path="/PurchaseReturnEdit/:id" component={PurchaseReturnEdit} />
            <Route path="/PurchaseReturnDetails/:id" component={PurchaseReturnDetails} />
            

            {/* Report */}
            <Route path="/CreditorDebitorReport" component={CreditorDebitorReport} />
            <Route path="/CustomerOutstandingReport" component={CustomerOutstandingReport} />
            <Route path="/SupplierOutstandingReport" component={SupplierOutstandingReport} />
            <Route path="/StockItemReport" component={StockItemReport} />
            <Route path="/StockRawMaterialReport" component={StockRawMaterialReport} />
            <Route path="/Ledger" component={Ledger} />
            <Route path="/PurchaseRegisterReport" component={PurchaseRegisterReport} />
            <Route path="/SaleRegister" component={SaleRegister} />
            <Route path="/CashBook" component={CashBook} />
            <Route path="/Salegstreport" component={Salegstreport} />
            <Route path="/SaleHSNCReport" component={SaleHSNCReport} />
            <Route path="/Stock" component={Stock} />
            <Route path="/TrialBalanceReport" component={TrialBalanceReport} />
            <Route path="/DailySaleProfitReport" component={DailySaleProfitReport} />
            <Route path="/SaleAnalysisReport" component={SaleAnalysisReport} />
            <Route path="/PartyandItemWiseReport" component={PartyandItemWiseReport} />
            <Route path="/PurchasePartyandItemWiseReport" component={PurchasePartyandItemWiseReport} />

            {/* StockJournal */}
            <Route path="/StockJournalIndex" component={StockJournalIndex} />
            <Route path="/StockJournalCreate" component={StockJournalCreate} />
            <Route path="/StockJournalDetails/:id" component={StockJournalDetails} />
            <Route path="/StockJournalEdit/:id" component={StockJournalEdit} />

            {/* Sale Return */}
            <Route path="/SaleReturnIndex" component={SaleReturnIndex} />
            <Route path="/SaleReturnCreate/:id" component={SaleReturnCreate} />
            <Route path="/SaleReturnEdit/:id" component={SaleReturnEdit} />
            <Route path="/SaleReturnDetails/:id" component={SaleReturnDetails} />

            {/* Income Or Expense */}
            <Route path="/IncomeExpenseIndex" component={IncomeExpenseIndex} />
            <Route path="/IncomeExpenseCreate" component={IncomeExpenseCreate} />
            <Route path="/IncomeExpenseEdit/:id" component={IncomeExpenseEdit} />
            <Route path="/IncomeExpenseDetails/:id" component={IncomeExpenseDetails} />
            {/* Payment And Receipt */}
            <Route path="/PaymentAndReceiptIndex" component={PaymentAndReceiptIndex} />
            <Route path="/PaymentAndReceiptCreate" component={PaymentAndReceiptCreate} />
            <Route path="/PaymentAndReceiptDetails/:id" component={PaymentAndReceiptDetails} />
            <Route path="/PaymentAndReceiptEdit/:id" component={PaymentAndReceiptEdit} />

            {/* Payment And Receipt */}
            <Route path="/CompanyEdit" component={CompanyEdit} />
          </Switch>
        </Container>

      </AuthProvider>
    </Router>
  );
};

export default App;

